// extracted by mini-css-extract-plugin
export default {"edgeContainer":"LineEdgeActionBar_edgeContainer__kgwPu"};